import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ThemeToggle from './components/ThemeToggle';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminCourses from './pages/AdminCourses';
import CoursePage from './pages/CoursePage';
import './App.css';
import AcademiaVendas from './pages/AcademiaVendas';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  
  console.log('PrivateRoute - Loading:', loading);
  console.log('PrivateRoute - User:', user);
  console.log('PrivateRoute - isAuthenticated:', isAuthenticated());
  
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }
  
  const hasToken = !!localStorage.getItem('token');
  const hasUser = !!localStorage.getItem('user');
  
  if (!isAuthenticated() && !(hasToken && hasUser)) {
    console.log('PrivateRoute - Redirecionando para login');
    return <Navigate to="/login" />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <div className="app">
      <ThemeToggle />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
<Route
  path="/treinamento"
  element={
    <PrivateRoute>
      <AcademiaVendas />
    </PrivateRoute>
  }
/>
          <Route
            path="/admin/courses"
            element={
              <PrivateRoute>
                <AdminCourses />
              </PrivateRoute>
            }
          />
          <Route
            path="/course/:courseId"
            element={
              <PrivateRoute>
                <CoursePage />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
